module.exports = __webpack_public_path__ + "static/media/team-pouya.731c15bd.jpg";